document.addEventListener('DOMContentLoaded', function() {
  const bundleSections = document.querySelectorAll('.nube-bundle');

  bundleSections.forEach(section => {
    const sectionId = section.dataset.section;
    const jsonScript = document.getElementById(`BundleProductJson-${sectionId}`);
    if (!jsonScript) return;
    
    const productData = JSON.parse(jsonScript.innerHTML);
    const variants = productData.variants;
    
    // State
    let targetQty = 1;
    let selectedTierDiscount = 0;
    const cartSelections = {}; // format: { variantId: { qty: 1, color: 'Beige', size: '36/37' } }
    
    // Elements
    const tiers = section.querySelectorAll('.nube-bundle__tier');
    const togoParent = section.querySelector('.nube-bundle__togo-badge');
    const submitBtn = section.querySelector('.nube-bundle__submit-btn');
    const submitText = section.querySelector('.nube-bundle__submit-text');
    const rows = section.querySelectorAll('.nube-bundle__variant-row');
    const showMoreBtn = section.querySelector('.nube-bundle__show-more');
    
    // Helper to format money
    function formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      let value = '';
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let formatString = (format || '${{amount}}');
      
      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }
      
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
      
        if (isNaN(number) || number == null) { return 0; }
      
        number = (number / 100.0).toFixed(precision);
      
        let parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
      
        return dollars + cents;
      }

      const match = formatString.match(placeholderRegex);
      if(!match) return `$${(cents/100).toFixed(2)}`;

      switch(match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
    
    // 1. Setup Tiers
    tiers.forEach(tier => {
      tier.addEventListener('click', () => {
        tiers.forEach(t => t.classList.remove('is-selected'));
        tier.classList.add('is-selected');
        
        targetQty = parseInt(tier.dataset.qty);
        selectedTierDiscount = parseFloat(tier.dataset.discount) || 0;
        
        updateUI();
      });
      
      // Calculate display price for tier based on discount
      const priceSpan = tier.querySelector('.nube-bundle__calculated-price');
      if (priceSpan) {
        const qty = parseInt(priceSpan.dataset.qty);
        const discount = parseFloat(priceSpan.dataset.discount) || 0;
        const subtotal = (productData.price / 100) * qty;
        const discountedTotal = subtotal * (1 - (discount / 100));
        let perPair = discountedTotal / qty;
        
        priceSpan.innerHTML = formatMoney(perPair * 100, productData.moneyFormat);
      }
    });
    
    // 2. Setup Rows & Selectors
    rows.forEach((row, index) => {
      // Hide rows after first 3
      if (index > 2) {
        row.style.display = 'none';
      }
      
      const color = row.dataset.color;
      const sizeSelect = row.querySelector('.nube-bundle__size-select');
      const addBtn = row.querySelector('.nube-bundle__add-btn');
      const tagsContainer = row.querySelector('.nube-bundle__selected-tags');
      
      // Filter available sizes for this color
      const matchingVariants = variants.filter(v => v[`option${parseInt(productData.colorOptionIndex) + 1}`] === color);
      
      // Update select options based on availability
      Array.from(sizeSelect.options).forEach(opt => {
        if(opt.value === "") return; // Skip placeholder
        const variant = matchingVariants.find(v => v[`option${parseInt(productData.sizeOptionIndex) + 1}`] === opt.value);
        if(!variant || !variant.available) {
            opt.disabled = true;
            opt.text += ' (Agotado)';
        }
      });
      
      // Handle Add click
      addBtn.addEventListener('click', () => {
        if (!sizeSelect.value) {
            alert('Por favor selecciona una talla primero.');
            sizeSelect.focus();
            return;
        }
        
        const currentTotal = getTotalQty();
        if (currentTotal >= targetQty) {
            alert(`Ya has seleccionado la cantidad de tu combo (${targetQty}).`);
            return;
        }
        
        const size = sizeSelect.value;
        const variant = matchingVariants.find(v => v[`option${parseInt(productData.sizeOptionIndex) + 1}`] === size);
        
        if (!variant) return;
        
        if (cartSelections[variant.id]) {
            cartSelections[variant.id].qty += 1;
        } else {
            cartSelections[variant.id] = { qty: 1, color, size };
        }
        
        renderTags(tagsContainer, color);
        updateUI();
      });
      
    });

    // Handle tags removal inside row using event delegation
    rows.forEach(row => {
      const tagsContainer = row.querySelector('.nube-bundle__selected-tags');
      const color = row.dataset.color;
      tagsContainer.addEventListener('click', (e) => {
        if(e.target.closest('.nube-bundle__tag-remove')) {
          const variantId = e.target.closest('.nube-bundle__tag').dataset.id;
          if (cartSelections[variantId]) {
            cartSelections[variantId].qty -= 1;
            if(cartSelections[variantId].qty <= 0) {
              delete cartSelections[variantId];
            }
            renderTags(tagsContainer, color);
            updateUI();
          }
        }
      });
    });
    
    // Show More toggle
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', () => {
        const isHidden = rows[3] && rows[3].style.display === 'none';
        if(isHidden === undefined) return;
        rows.forEach((row, index) => {
          if (index > 2) {
            row.style.display = isHidden ? 'flex' : 'none';
          }
        });
        showMoreBtn.classList.toggle('is-open');
        showMoreBtn.innerHTML = isHidden ? 
            'Ocultar colores <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>' : 
            'Scroll para más colores <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      });
    }

    function renderTags(container, color) {
        container.innerHTML = '';
        Object.keys(cartSelections).forEach(id => {
            const item = cartSelections[id];
            if (item.color === color) {
                const tag = document.createElement('div');
                tag.className = 'nube-bundle__tag';
                tag.dataset.id = id;
                tag.innerHTML = `${item.size} &times; ${item.qty} <span class="nube-bundle__tag-remove" style="padding-left: 4px;font-size:16px;">&times;</span>`;
                container.appendChild(tag);
            }
        });
    }

    function getTotalQty() {
        return Object.values(cartSelections).reduce((sum, item) => sum + item.qty, 0);
    }
    
    function updateUI() {
        // Find default target qty if not clicked
        if(tiers[0] && (targetQty === 1 || !targetQty)) {
            targetQty = parseInt(tiers[0].dataset.qty);
            selectedTierDiscount = parseFloat(tiers[0].dataset.discount) || 0;
        }

        const currentQty = getTotalQty();
        const remaining = targetQty - currentQty;
        
        // Update To Go
        if (remaining <= 0 && currentQty > 0 && remaining === 0) {
            togoParent.style.backgroundColor = '#d4edda';
            togoParent.innerHTML = '¡COMPLETO!';
        } else if (remaining < 0) {
            togoParent.style.backgroundColor = '#f8d7da';
            togoParent.innerHTML = `SOBRAN ${Math.abs(remaining)}`;
        } else {
            togoParent.style.backgroundColor = '#e6f0ff';
            togoParent.innerHTML = `<span id="nube-bundle-togo">${remaining}</span> FALTAN`;
        }
        

        // Calculate final price with discount for the target quantity
        const basePrice = productData.compare_at_price || productData.price;
        const subtotalOriginal = (basePrice / 100) * targetQty;
        const subtotalCurrent = (productData.price / 100) * targetQty;
        const finalTotal = subtotalCurrent * (1 - (selectedTierDiscount / 100));

        let priceHtml = '';
        const finalStr = formatMoney(finalTotal * 100, productData.moneyFormat);
        // If there's a discount or compare price is higher than final total, show the pill with strikethrough
        if (subtotalOriginal > finalTotal) {
            const originalStr = formatMoney(subtotalOriginal * 100, productData.moneyFormat);
            priceHtml = `<div class="nube-bundle__submit-price-pill"><del>${originalStr}</del> <strong>${finalStr}</strong></div>`;
        } else {
            priceHtml = `<div class="nube-bundle__submit-price-pill"><strong>${finalStr}</strong></div>`;
        }

        // Update Footer Button
        if (currentQty === targetQty) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = `<span>COMPRAR AHORA</span>${priceHtml}`;
        } else if (currentQty > targetQty) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = `<span>TIENES ${Math.abs(remaining)} DE MÁS</span>${priceHtml}`;
        } else {
            submitBtn.disabled = true;
            submitBtn.innerHTML = `<span>SELECCIONA ${targetQty} PAR(ES)</span>${priceHtml}`;
        }
    }
    
    // Initialize
    updateUI();
    
    // Handle Submit
    submitBtn.addEventListener('click', () => {
        if (getTotalQty() !== targetQty) return;
        
        submitBtn.disabled = true;
        const originalText = submitBtn.innerHTML;
        submitBtn.innerHTML = 'AÑADIENDO...';
        
        const items = Object.keys(cartSelections).map(id => ({
            id: parseInt(id),
            quantity: cartSelections[id].qty
        }));
        
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
        })
        .then(response => {
            return response.json();
        })
        .then((data) => {
            window.location.href = '/checkout';
        })
        .catch((error) => {
            console.error('Error:', error);
            submitBtn.disabled = false;
            submitBtn.innerHTML = 'ERROR. INTENTA NUEVAMENTE';
        });
    });

  });
});
